/**
 * @generated SignedSource<<b5ece995d5336893a3d038e4fba6e8d5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type featureFlagsEmptyState_softwareReleasesVersionDetailIssueList_FeatureFlagEmptyStateExperienceModal$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"async_softwareEmptyStateExperienceFeatureFlags_FeatureFlagEmptyStateExperienceEntryPoint">;
  readonly " $fragmentType": "featureFlagsEmptyState_softwareReleasesVersionDetailIssueList_FeatureFlagEmptyStateExperienceModal";
}>;
export type featureFlagsEmptyState_softwareReleasesVersionDetailIssueList_FeatureFlagEmptyStateExperienceModal$key = ReadonlyArray<{
  readonly " $data"?: featureFlagsEmptyState_softwareReleasesVersionDetailIssueList_FeatureFlagEmptyStateExperienceModal$data;
  readonly " $fragmentSpreads": FragmentRefs<"featureFlagsEmptyState_softwareReleasesVersionDetailIssueList_FeatureFlagEmptyStateExperienceModal">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "featureFlagsEmptyState_softwareReleasesVersionDetailIssueList_FeatureFlagEmptyStateExperienceModal",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "async_softwareEmptyStateExperienceFeatureFlags_FeatureFlagEmptyStateExperienceEntryPoint"
    }
  ],
  "type": "DevOpsFeatureFlagProvider"
};

(node as any).hash = "0fbad5b696ab8a25991a0d1c79838173";

export default node;
